import moment from "moment";
import {
  GET_CLIENT_LOGO,
  SET_ORDER_BY,
  SET_PAGE,
  SET_SEARCH,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialClientLogo = {
  clientLogo: [],
  clientLogoCount: 0,
  page: 1,
  search: "",
  orderby: "desc",
  sortby: "",
};

function clientLogoReducer(state = initialClientLogo, action) {
  switch (action.type) {
    case GET_CLIENT_LOGO:
      return {
        ...state,
        clientLogo: action.payload.clientLogos.map((logo) => {
          return {
            ...logo,
            updatedAtFormat: moment(logo.updatedAt).format("ll"),
          };
        }),
        clientLogoCount: action.payload.total,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    default:
      return state;
  }
}

export default clientLogoReducer;
